import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, CheckIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-stage tech-grid py-16 sm:py-20" aria-labelledby="system-title" data-id="element-233" data-mp="3bhljv43cc8l2">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-234" data-mp="36iqv7liozpt1">
        <span className="metal-surface inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navyDeep" data-id="element-235" data-mp="31kpdb3x05wj5">
          <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-236" data-mp="2wsfr9yz0dgm5" /> The most comprehensive meteorology teaching system in the
          world
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-237" data-mp="2ntkf869a9cax">
          Meteorology &amp; Atmospheric Science Teacher Ready
        </h2>
        <p className="mt-3 font-semibold text-silver" data-id="element-238" data-mp="2dumkump6eok0">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach atmospheric science
          with confidence.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-239" data-mp="18q6fsel0tuvt">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-silverEdge bg-navyPanel p-4 text-sm font-semibold text-silver" data-id="element-240" data-mp="u2lgywv6ihtp">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-241" data-mp="1cr04vba79fqa" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-silver/40 bg-white/5 p-6 text-left text-lg font-bold leading-relaxed text-silverBright" data-id="element-242" data-mp="1bv0m2uf794k">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-silver" aria-hidden="true" data-id="element-243" data-mp="28y4tsgtskh1d" />
          It's a complete system so you can enter the classroom with confidence and deliver lessons that truly teach how
          Earth's atmosphere works, changes, and affects us all.
        </p>
      </div>
    </section>;
}